import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 15px 0px 15px;
  margin-bottom: 10px;

  .tag-list {
    display: flex;
    flex-direction: row;
    width: 370px;
    max-width: 370px;

    .header {
      width: 30%;
    }

    .content {
      display: flex;
      width: 70%;
      flex-wrap: wrap;
      gap: 5px;
      justify-content: start;
    }
  }
`;

export const Title = lib.styled.div`
  font-size: ${fonts.default}px;
  font-weight: bold;
  color: black;
  opacity: 0.5;
  font-size: 15;
  margin-right: 10px;
`;

export const Tag = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  cursor: pointer;
  margin-right: 5px;
  border-radius: 30px;

  .circle {
    width: 15px;
    height: 15px;
    background-color: ${props => props.color};
    border-radius: 15px;

    &:hover {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 15px;
      padding-left: 10px;
      padding-right: 10px;
      width: unset !important;

      .icon-delete {
        display: block;
        width: 12px !important;
        height: 12px !important;
        margin-left: -5px !important;
        margin-right: 5px !important;
      }

      .tag-name {
        font-size: 10px;
        font-weight: 700;
        color: ${colors.white};
        display: block;
      }
    }

    .tag-name {
      display: none;
    }

    .icon-delete {
      display: none;
    }
  }
`;
